module.exports = __webpack_public_path__ + "img/skills-bow-ama-1.332c4de9.png";